import { computed, ref, watch } from 'vue';
import i18n from '@/i18n';

export const useCountDown = () => {
  const timer = ref();
  const countDown = ref();
  const timeRemaining = ref();
  const lastTime = ref(Date.now());

  watch(countDown, val => {
    if (timer.value) {
      clearInterval(timer.value);
    }
    timeRemaining.value = val;
    lastTime.value = Date.now();
    timer.value = setInterval(() => {
      const now = Date.now();
      let diff = Math.floor((now - lastTime.value) / 1000);
      lastTime.value = now;
      if (diff < 1) {
        diff = 1;
      }
      timeRemaining.value -= diff;
      if (timeRemaining.value <= 0) {
        timeRemaining.value = 0;
        clearInterval(timer.value);
      }
    }, 1000);
  });

  const countDownText = key =>
    computed(() => {
      if (timeRemaining.value) {
        return i18n.tc(key, timeRemaining.value, { number: timeRemaining.value });
      } else {
        return '';
      }
    });

  return { countDown, timeRemaining, countDownText };
};
